module.exports = __webpack_public_path__ + "img/Edit_Icon_White.26726b5a.svg";